import { useEffect, useState } from "react";
import { api, formatNumber } from "@/lib/api";

/** Minimal creator/admin analytics — where is my MESSAGE actually travelling from? */
export default function CreatorAnalytics({ messageId, enabled = false }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    // Gate the request on the backend's authoritative `can_see_analytics`
    // flag from GET /messages/{id}. Non-creators / non-admins never fire
    // the request, so the console stops carrying guaranteed 401/403s.
    if (!enabled) { setData(null); setErr(null); return; }
    api.get(`/messages/${messageId}/analytics`)
      .then((r) => setData(r.data))
      .catch((e) => setErr(e?.response?.status || "err"));
  }, [messageId, enabled]);
  if (!enabled) return null;
  if (err) return null;  // hide silently for non-creators/non-admins
  if (!data) return null;

  const rows = Object.entries(data.by_source || {})
    .sort((a, b) => (b[1].view + b[1].open) - (a[1].view + a[1].open));

  return (
    <div className="mt-12 pt-8 border-t oh-hairline" data-testid="creator-analytics">
      <div className="oh-label">Where is my MESSAGE travelling from?</div>
      <div className="mt-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="oh-label text-[color:var(--oh-ink-3)]">
            <tr>
              <th className="py-2 text-left">Source</th>
              <th className="py-2 text-right">Entries</th>
              <th className="py-2 text-right">Voices</th>
              <th className="py-2 text-right">Pass it on</th>
              <th className="py-2 text-right">Downstream</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={5} className="py-6 text-[color:var(--oh-ink-3)]">
                Nothing yet — share your MESSAGE to start attribution.
              </td></tr>
            )}
            {rows.map(([src, v]) => (
              <tr key={src} className="border-t oh-hairline"
                  data-testid={`creator-analytics-row-${src}`}>
                <td className="py-3 uppercase tracking-wider text-xs">{src}</td>
                <td className="py-3 text-right">{formatNumber((v.open || 0) + (v.scan || 0) + (v.view || 0))}</td>
                <td className="py-3 text-right">{formatNumber(v.voices || 0)}</td>
                <td className="py-3 text-right">{formatNumber(v.pass_it_on || 0)}</td>
                <td className="py-3 text-right">{formatNumber(v.downstream_voices || 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="oh-label mt-3 text-[color:var(--oh-ink-3)]">
        Only your MESSAGE's creator (and admins) can see this.
      </div>
    </div>
  );
}
